import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, GetListNewBO, saveListBO } from './list.model';
import { ListService } from './list.service';
import { ListDateService } from './listdateservice';


@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  ListForm: FormGroup;
  ListType: string;
  public filterSettings: object;
  Deleteid: any;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  @ViewChild('gridList') public gridList: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  saveListFields: saveListBO = new saveListBO();
  FilterBo: GetListNewBO = new GetListNewBO();
  isSaveorUpdateBoolean:boolean=false;
  constructor(public getListService: ListDateService,
    public global: GlobalComponent, private formBuilder: FormBuilder,
    public LService: ListService, public toasterService: ToastrService,) {
    this.ListForm = this.formBuilder.group({
      LocationName: [' ', Validators.required],
      ListCode: [' ', Validators.required],
      isAvailable: ['']
    });
    this.global.checkforlogout();
    this.GridList = getListService;
  }
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getListFilter();
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "List");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.LService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  //.........................................CreateLocationList.............................................
  CreateorUpdateList(data) {
    this.ListType = data;
    if (this.ListType == 'CreatelistModal') {
      this.saveListFields = new saveListBO();
      this.ListForm.reset();
    }
  }
  // ................................................dataChangeList..............................................
  public dataChangeList(L): void {
    let val = (L.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((L.sorted || []).length) {
        this.FilterBo.orderColumn = L.sorted[0].name;
        this.FilterBo.orderType = L.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && L.action.action != "clearFilter") {
      this.FilterBo.value = L.action.currentFilterObject.value;
      this.FilterBo.field = L.action.currentFilterObject.field;
      this.FilterBo.matchCase = L.action.currentFilterObject.matchCase;
      this.FilterBo.operator = L.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && L.action.action == "clearFilter") {
        this.FilterBo.field = "listName";
        this.FilterBo.matchCase = false;
        this.FilterBo.operator = "contains";
        this.FilterBo.value = "";
        this.FilterBo.type = "string";
      }
    }
    this.getListFilter();
    if (val == "paging" && L.action.name == "actionBegin") {
   
    }
  }
  //.........................................onActionList.....................................................
  public onActionList(L) {
    this.FilterBo.currentpageno = this.gridList.pagerModule.pagerObj.currentPage;
    this.FilterBo.pageitem = this.gridList.pagerModule.pagerObj.pageSize;
    if (L.name == "actionBegin" && L.requestType == "filterbeforeopen") {
      this.FilterBo.type = L.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveListBO) {
    this.saveListFields = JSON.parse(JSON.stringify(saveBos));
  }
  //.........................................Refresh.............................................
  clearlist(type: string) {
    this.ListType = null;
    this.saveListFields = new saveListBO();
    this.ListForm.reset();
    if (type == "refresh") {
      this.getListFilter();
    }
  }
  //.........................................getListFilter.............................................
  getListFilter() {
    // this.FilterBo.agencyId = this.global.globalAgencyId;
    this.getListService.execute(this.FilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridList.height = '500';
      }
      else {
        this.gridList.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateList.............................................
  SaveOrUpdateList() {
    this.isSaveorUpdateBoolean=true;
    let saveListitems: saveListBO = JSON.parse(JSON.stringify(this.saveListFields));

    saveListitems.id = this.saveListFields.id;
    if (this.saveListFields.isAvailableToAgency == null || this.saveListFields.isAvailableToAgency == undefined || this.saveListFields.isAvailableToAgency == false) {
      saveListitems.isAvailableToAgency = false;
    }
    this.LService.SaveorUpdateList(saveListitems).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        if (this.ListType == 'CreatelistModal') {
          this.toasterService.success('List saved successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);

        }
        else if (this.ListType == 'UpdatelistModal') {
          this.toasterService.success('List updated successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
        document.getElementById('openListModal').click();
        this.ListForm.reset();
        this.FilterBo = new GetListNewBO();
        this.saveListFields = new saveListBO();
        this.getListFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }
  //.....................................showLocationColumns....................................
  showLocationColumns() {
    this.gridList.columnChooserModule.openColumnChooser(200, 50);
  }
  setDeleteid(data) {
    this.Deleteid = data;
  }
  //..........................................DeleteLocation...........................................................
  DeleteList() {
    this.LService.DeleteList(this.saveListFields.id).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterService.success('List deleted successfully!');
      setTimeout(() => {
        this.toasterService.clear();
      }, 8000);
      this.saveListFields = new saveListBO();
      this.FilterBo = new GetListNewBO();
      document.getElementById('closeListModal').click();
      this.getListFilter();
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    });


  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
